import React from "react";
import {
  Grid,
  MenuItem,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PercentOutlined from "@mui/icons-material/PercentOutlined";
import AttachMoneyOutlined from "@mui/icons-material/AttachMoneyOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FormField from "./FormField";

const CurrencyChargesStep = ({ formData, handleChange }) => {
  const theme = useTheme();

  return (
    <Grid container spacing={3}>
      <Grid item size={12}>
        <Accordion
          defaultExpanded
          disableGutters
          sx={{
            borderRadius: "12px !important",
            border: "1px solid #D9E2EC",
            boxShadow: "none",
            "&:before": { display: "none" },
            mb: 1,
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#64748B" }} />}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "0.86rem",
                color: "#334155",
                fontFamily: '"exo", "Inter", sans-serif',
              }}
            >
              Currency and tax setup
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0 }}>
            <Grid container spacing={3}>
              <FormField
                label="VAT Rate (%) (Optional)"
                name="vatRate"
                type="number"
                value={formData.vatRate}
                onChange={handleChange("vatRate")}
                placeholder="10"
                icon={<PercentOutlined sx={{ color: "#F9735B" }} />}
                gridSize={{ xs: 12, md: 6 }}
              />

              <FormField
                label="Currency (Optional)"
                name="currency"
                value={formData.currency}
                onChange={handleChange("currency")}
                icon={<AttachMoneyOutlined sx={{ color: "#F9735B" }} />}
                select
                gridSize={{ xs: 12, md: 6 }}
              >
                <MenuItem value="USD">USD - US Dollar</MenuItem>
                <MenuItem value="EUR">EUR - Euro</MenuItem>
                <MenuItem value="GBP">GBP - British Pound</MenuItem>
                <MenuItem value="INR">INR - Indian Rupee</MenuItem>
                <MenuItem value="LKR">LKR - Sri Lankan Rupee</MenuItem>
              </FormField>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>

      <Grid item size={12}>
        <Accordion
          expanded={true}
          disableGutters
          sx={{
            borderRadius: "12px !important",
            border: "1px solid #D9E2EC",
            boxShadow: "none",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#64748B" }} />}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                fontFamily: theme.typography.fontFamily,
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#F9735B",
              }}
            >
              <PercentOutlined sx={{ color: "#F9735B" }} />
              Company Charges (Optional)
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ pt: 0 }}>
            <Grid container spacing={3}>
              <FormField
                label="Dine-in Charge (%) (Optional)"
                name="serviceChargeRateDining"
                type="number"
                value={formData.serviceChargeRateDining}
                onChange={handleChange("serviceChargeRateDining")}
                placeholder="0"
                gridSize={12}
              />

              <FormField
                label="Takeaway Charge (%) (Optional)"
                name="serviceChargeRateTakeaway"
                type="number"
                value={formData.serviceChargeRateTakeaway}
                onChange={handleChange("serviceChargeRateTakeaway")}
                placeholder="0"
                gridSize={{ xs: 12, md: 6 }}
              />

              <FormField
                label="Delivery Charge (%) (Optional)"
                name="serviceChargeRateDelivery"
                type="number"
                value={formData.serviceChargeRateDelivery}
                onChange={handleChange("serviceChargeRateDelivery")}
                placeholder="0"
                gridSize={{ xs: 12, md: 6 }}
              />
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </Grid>
  );
};

export default CurrencyChargesStep;
